import { makeSimpleDigitalSensorElement } from "./simpleDigitalSensorElements.js";

export const gen4SolenoidVerificationElementConfig = makeSimpleDigitalSensorElement("code", 1);
export const saplingVerificationElementConfig = makeSimpleDigitalSensorElement("code", 1);
